/* eslint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

// eslint-disable-next-line react/display-name
const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icons/Action/24/Search">
        <path
          fill="currentColor"
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5039 1.00415C5.2572 1.00415 1.00391 5.25745 1.00391 10.5042C1.00391 15.7509 5.2572 20.0042 10.5039 20.0042C12.767 20.0042 14.8452 19.2128 16.4771 17.8918L21.5823 22.9967L22.9965 21.5825L17.8913 16.4776C19.2125 14.8457 20.0039 12.7674 20.0039 10.5042C20.0039 5.25745 15.7506 1.00415 10.5039 1.00415ZM3.00391 10.5042C3.00391 6.36201 6.36177 3.00415 10.5039 3.00415C14.646 3.00415 18.0039 6.36201 18.0039 10.5042C18.0039 14.6463 14.646 18.0042 10.5039 18.0042C6.36177 18.0042 3.00391 14.6463 3.00391 10.5042Z"
        />
        <path
          fill="currentColor"
          id="Rectangle 3979 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 13V10L7 12V15H14V12L12 10V13H9Z"
        />
        <path id="Rectangle 3980" d="M15.5 10.5L10.5 5.49999L5.49998 10.5" stroke="currentColor" strokeWidth="2" />
      </g>
    </svg>
  );
});

export const IconInspection24: React.FC<ISVGIconProps> = createIcon(IconComponent);
